// src/components/YouTubeSection.jsx
import { motion } from 'framer-motion';
import RecentVideos from './RecentVideos';
import { translations } from '../locales/translations';

function YouTubeSection({ lang = 'ko' }) {
  const t = translations[lang];

  return (
    <section className="py-20 px-4 bg-neutral">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-12">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-5xl md:text-6xl font-title font-bold text-primary tracking-wide"
          >
            {t.youtube.title}
          </motion.h2>

          <a
            href="https://www.youtube.com/@hansomang_church-s1q"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center px-8 py-4 bg-primary text-white rounded-lg hover:bg-secondary transition-colors duration-300"
          >
            <span className="text-lg font-heading font-bold tracking-wide">
              {t.youtube.channelButton}
            </span>
            <svg className="w-6 h-6 ml-3" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
            </svg>
          </a>
        </div>

        {/* YouTube 동영상 목록 */}
        <RecentVideos lang={lang} />
      </div>
    </section>
  );
}

export default YouTubeSection;